//// =====================================================
//   Shared API authentication
//// =====================================================
// Every request to the shared API must carry an "ApiKey" header built from two
// parts joined by "_": a constant secret, then the current UTC time expressed as
// .NET DateTime ticks (100-nanosecond intervals since 0001-01-01).

const API_KEY_SECRET = 'xlw($q67^4mR_~Ss323#XB_)z]J(p;5$.I-b;HTXqskaknxJLD';

// Ticks between 0001-01-01 and the Unix epoch, and ticks per millisecond.
// BigInt keeps the precision that Number loses beyond 2^53.
const TICKS_AT_UNIX_EPOCH = BigInt('621355968000000000');
const TICKS_PER_MILLISECOND = BigInt('10000');

const utcNowTicks = () => BigInt(Date.now()) * TICKS_PER_MILLISECOND + TICKS_AT_UNIX_EPOCH;

// Built per request so the ticks part is always current.
export const sharedApiKey = () => `${API_KEY_SECRET}_${utcNowTicks()}@`;

export const sharedApiHeaders = (headers: Record<string, string> = {}) => ({
    ...headers,
    ApiKey: sharedApiKey(),
});
